// extracted by mini-css-extract-plugin
export default {"title":"Q_GG4","text":"RkYBk","similarItemsFailure":"F_fLE","faceEmoji":"ZZWto"};